"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var AdobeEvent_1 = require("./AdobeEvent");
var FasVapAdobeLaunch_1 = require("./FasVapAdobeLaunch");
var LocalStorageService_1 = require("./services/LocalStorageService");
var LoggedOnStatusService_1 = require("./services/LoggedOnStatusService");
var PageLoadDataService_1 = require("./services/PageLoadDataService");
var UserDetailsService_1 = require("./services/UserDetailsService");
var WindowService_1 = require("./services/WindowService");
var FasAdobeLaunch = (function () {
    function FasAdobeLaunch() {
        this.localStorageService = new LocalStorageService_1.default();
        this.userDetails = new UserDetailsService_1.default();
        this.vapAdobeLaunch = new FasVapAdobeLaunch_1.default();
    }
    FasAdobeLaunch.prototype.getLocalStorageService = function () {
        return this.localStorageService;
    };
    FasAdobeLaunch.prototype.trackEvent = function (eventName, eventDataName, eventData) {
        var adobeEvent = new AdobeEvent_1.default(eventName, eventDataName, eventData);
        WindowService_1.default.pushToDatalayer(adobeEvent.getData());
    };
    FasAdobeLaunch.prototype.trackDelayedEvent = function (eventName, eventDataName, eventData) {
        var adobeEvent = new AdobeEvent_1.default(eventName, eventDataName, eventData);
        this.localStorageService.addEventDataItem(adobeEvent);
    };
    FasAdobeLaunch.prototype.trackUserData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var userInfo, isUserLoggedIn;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.userDetails.getUserInfo()];
                    case 1:
                        userInfo = _a.sent();
                        isUserLoggedIn = LoggedOnStatusService_1.default.isLoggedIn(userInfo.loginStatus);
                        this.trackUserSignedIn(userInfo, isUserLoggedIn);
                        this.trackUserDetected(userInfo, isUserLoggedIn);
                        return [2];
                }
            });
        });
    };
    FasAdobeLaunch.prototype.trackUserSignedIn = function (userInfo, isUserLoggedIn) {
        if (this.localStorageService.hasItem('userSignedIn')) {
            if (isUserLoggedIn) {
                this.trackEvent('userSignedIn', 'user', userInfo);
            }
            this.localStorageService.removeItem('userSignedIn');
        }
    };
    FasAdobeLaunch.prototype.trackUserDetected = function (userInfo, isUserLoggedIn) {
        if (isUserLoggedIn) {
            this.trackUserDetectedEventForLogin(userInfo);
        }
        else {
            var loggedOffUserInfo = {
                loginStatus: LoggedOnStatusService_1.default.LOGGED_OFF
            };
            if (userInfo && userInfo.crmContactID) {
                var crmContactID = 'crmContactID';
                loggedOffUserInfo[crmContactID] = userInfo.crmContactID;
            }
            this.trackEvent('userDetected', 'user', loggedOffUserInfo);
        }
    };
    FasAdobeLaunch.prototype.trackLocalStorageEvents = function () {
        var eventDataItems = this.localStorageService.get();
        for (var _i = 0, eventDataItems_1 = eventDataItems; _i < eventDataItems_1.length; _i++) {
            var eventDataItem = eventDataItems_1[_i];
            WindowService_1.default.pushToDatalayer(eventDataItem);
        }
        this.localStorageService.clear();
    };
    FasAdobeLaunch.prototype.trackSearchResultsReached = function (searchInfo) {
        this.trackEvent('searchResultsReached', 'searchInfo', searchInfo);
    };
    FasAdobeLaunch.prototype.trackSearchConducted = function (searchInfo) {
        this.trackEvent('searchConducted', 'searchInfo', searchInfo);
    };
    FasAdobeLaunch.prototype.trackSearchResultClicked = function (searchInfo) {
        this.trackEvent('searchResultClicked', 'searchInfo', searchInfo);
    };
    FasAdobeLaunch.prototype.trackNavigationClick = function (navigationData) {
        this.trackDelayedEvent('navigationClicks', 'navigation', navigationData);
    };
    FasAdobeLaunch.prototype.trackSignInClick = function () {
        this.userDetails.clearCache();
        this.trackDelayedEvent('userSignedIn', 'user', { signInClicked: true });
    };
    FasAdobeLaunch.prototype.trackSubpageViewed = function (subPageID, tabClicked) {
        this.trackEvent('subPageViewed', 'subPage', { subPageID: subPageID, tabClicked: tabClicked });
    };
    FasAdobeLaunch.prototype.trackMediaEvent = function (event, mediaName, mediaType, mediaCategory) {
        var videoData = {
            mediaName: mediaName,
            mediaCategory: mediaCategory,
            mediaType: mediaType
        };
        this.trackEvent(event, 'media', videoData);
    };
    FasAdobeLaunch.prototype.trackVideoPlayed = function (mediaName, mediaCategory) {
        this.trackMediaEvent('mediaPlay', mediaName, 'video', mediaCategory);
    };
    FasAdobeLaunch.prototype.trackVideoPaused = function (mediaName, mediaCategory) {
        this.trackMediaEvent('mediaPause', mediaName, 'video', mediaCategory);
    };
    FasAdobeLaunch.prototype.trackPodcastPlayed = function (mediaName, mediaCategory) {
        this.trackMediaEvent('mediaPlay', mediaName, 'podcast', mediaCategory);
    };
    FasAdobeLaunch.prototype.trackPodcastPaused = function (mediaName, mediaCategory) {
        this.trackMediaEvent('mediaPause', mediaName, 'podcast', mediaCategory);
    };
    FasAdobeLaunch.prototype.trackContentPrinted = function (fileName) {
        this.trackEvent('contentPrinted', 'file', { fileName: fileName });
    };
    FasAdobeLaunch.prototype.trackContentShared = function (shareType, linkName) {
        this.trackEvent('contentShared', 'medium', { shareType: shareType, linkName: linkName });
    };
    FasAdobeLaunch.prototype.trackContentDownloaded = function (fileName, litId, fundId) {
        var contentData = { fileName: fileName };
        if (litId) {
            contentData.litId = litId;
        }
        if (fundId) {
            contentData.fundId = fundId;
        }
        this.trackEvent('contentDownloaded', 'linkInfo', contentData);
    };
    FasAdobeLaunch.prototype.trackProductViewed = function (fundId, litId) {
        if (fundId === void 0) { fundId = 'Literature'; }
        var productInfo = { fundId: fundId };
        if (litId) {
            productInfo.litId = litId;
        }
        this.trackEvent('productViewed', 'product', [{ productInfo: productInfo }]);
    };
    FasAdobeLaunch.prototype.trackProductAdded = function (quantity, litId, fundId) {
        var product = { quantity: quantity };
        var productInfo = { litId: litId, fundId: fundId };
        product.productInfo = productInfo;
        this.trackEvent('productAdded', 'product', [product]);
    };
    FasAdobeLaunch.prototype.trackPageLoadEvent = function (data) {
        var pageData = PageLoadDataService_1.default.buildPageData(data);
        this.trackEvent('pageLoaded', 'page', pageData);
    };
    FasAdobeLaunch.prototype.trackPageLoadCompleted = function () {
        this.trackEvent('pageLoadCompleted');
    };
    FasAdobeLaunch.prototype.initializePage = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.trackPageLoadEvent(data);
                        return [4, this.trackUserData()];
                    case 1:
                        _a.sent();
                        this.trackLocalStorageEvents();
                        this.trackPageLoadCompleted();
                        return [2];
                }
            });
        });
    };
    FasAdobeLaunch.prototype.getPageName = function (data) {
        return PageLoadDataService_1.default.buildPageName(data);
    };
    FasAdobeLaunch.prototype.trackUserDetectedEventForLogin = function (userInfo) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            "event": "userDetected",
            "userDiscovery": {
                "firmCRD": userInfo.firmCRD,
                "repCRD": userInfo.repCRD
            },
            "user": userInfo
        });
    };
    return FasAdobeLaunch;
}());
exports.default = FasAdobeLaunch;
//# sourceMappingURL=FasAdobeLaunch.js.map